import type { TenantConfig } from '@/types/TenantConfig'

const black = '#191919'
const white = '#FFFFFF'
const primaryColor = '#228113'
const secondaryColor = '#F99D30'

export const wpz: TenantConfig = {
  logo: 'assets/wpz/static/logo.svg',
  teaserImageSize: {
    width: 320,
  },
  themeOptions: {
    logoHeight: '65px',
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,
    headerBackground: '#125D21',
    memberLinksColor: white,
    footerBackgroundColor: black,
    footerTextColor: white,
    cartHeaderBackgroundColor: black,
    dialog: {
      headerBackground: black,
      headerTextColor: white,
      headerIconColor: white,
    },
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/wpz/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-155px',
        mobile: '-140px',
      },
    },
  },
}
